import LocalStorage from 'commons/js/modules/local-storage';
import { PRINT_QUALITIES } from "commons/js/config/print";
import { PRINT_QUALITY } from 'commons/js/config/storage-keys';

const Storage = new LocalStorage();

export function getPrintPreference() {
  return Storage.get(PRINT_QUALITY) || MEConfig.get('preferences.print_quality') || PRINT_QUALITIES.DEFAULT;
}

export function setPrintPreference(quality) {
  return Storage.add(PRINT_QUALITY, quality);
}

export function clearPrintPreference() {
  return Storage.remove(PRINT_QUALITY);
}
